import './index.scss';
import React from 'react';
import type { Moment } from 'moment';
import { Segment } from 'tea-component';
import RangePicker from '@/pages/home/components/RangePicker';
import DataSourceSelector from '@/pages/intelligence/components/TeaSelector/AnnieSource';

export type TSegmentOptsItem = {
  disabled?: boolean;
  text: string | React.ReactElement;
  value: string;
};

// type TDate = Moment[];

export interface ISegmentConfig {
  mainSegment: string;
  segmentOptions: TSegmentOptsItem[];
  onSegmentChangeTrigger: (value: string) => void;
}

export interface IRangePickerConfig {
  time: Moment[];
  onChangeRangePicker: (Data: Moment, needFetch?: boolean) => void;
  locale: string;
}

export interface ISourceSelectorConfig {
  onChangeDataSource: (value: string) => void;
  dataSource: any;
}

export default function Filter(props: {
  segmentConfig: ISegmentConfig;
  rangePickerConfig: IRangePickerConfig;
  sourceSelectorConfig: ISourceSelectorConfig;
}) {
  const { segmentConfig, rangePickerConfig, sourceSelectorConfig } = props;

  // console.log('FilterFilter', props);

  const { mainSegment, segmentOptions, onSegmentChangeTrigger } = segmentConfig;
  const { locale, time, onChangeRangePicker } = rangePickerConfig;
  const { dataSource, onChangeDataSource } = sourceSelectorConfig;

  // console.debug('segmentConfig', {
  //   mainSegment,
  //   segmentOptions,
  //   onSegmentChangeTrigger,
  // });

  // console.debug('rangePicker', {
  //   locale,
  //   time,
  //   onChangeRangePicker,
  // });

  const needSource = mainSegment === 'total' || mainSegment === 'mobile';

  return (
    <div className="dbi-market-tabdetails-segment">
      <Segment
        className="segment-light"
        value={mainSegment}
        onChange={onSegmentChangeTrigger}
        options={segmentOptions}
      />

      <div className="search-item search-item-date">
        <RangePicker
          type="month"
          language={locale}
          calendarType="month"
          autoRange={{
            timeType: 'month',
            length: 0,
          }}
          value={time}
          className="search-border"
          showSelectType={false}
          showShortcut={false}
          onChange={(val: Moment) => {
            // console.debug('onChangeRangePicker', val);
            onChangeRangePicker(val);
          }}
        />
      </div>

      {needSource && (
        <DataSourceSelector
          type={'single'}
          key={'dataSourceSingle'}
          locale={locale}
          onConfirm={(val) => {
            // console.debug('onChangeDataSource', val);
            onChangeDataSource(val);
          }}
          value={dataSource}
          isSearchItemMargin={true}
          isShowButtonLabel={true}
        />
      )}
    </div>
  );
}
